<template>
  <div id="__app">
    <sprite />
    <Header />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/common/Header'
import Footer from '@/components/common/Footer'
import Sprite from '@/components/common/Sprite'

export default {
  name: 'App',
  components: {
    Sprite,
    Header,
    Footer
  }
}
</script>
